module.exports = __webpack_public_path__ + "img/icon-fotov.2e2a13cc.svg";